import { Typography, TypographyOwnProps } from "@mui/material";
import { TSSTextVariant, useSSTheme } from "../../reusable/hooks/useSSTheme";
import React from "react";

interface TSSTextProps extends Omit<TypographyOwnProps, "variant"> {
  children?: React.ReactNode;
  variant?: TSSTextVariant;
  color?: TypographyOwnProps["color"] | string;
  // rest props
  [k: string]: any;
}

export function SSText({
  variant = "body",
  children,
  color,
  ...restProps
}: TSSTextProps) {
  const ssTheme = useSSTheme();
  const variantFontSize = ssTheme.pxToRem(ssTheme.calcFontSize(variant));
  const captionSx = { display: "block", lineHeight: ssTheme.text.lineHeight }; // fix for caption line-height
  const bodySx = { fontSize: restProps?.fontSize || variantFontSize }; // 14px

  return (
    <Typography
      variant={variant == "body" ? "body1" : variant}
      fontSize={variantFontSize}
      lineHeight={ssTheme.text.lineHeight}
      color={color || ssTheme.colors.gray[400]}
      {...restProps}
      sx={{
        ...(variant == "caption" && captionSx),
        ...(variant == "body" && bodySx),
        ...restProps.sx,
      }}
    >
      {children}
    </Typography>
  );
}
